import React, { FC } from 'react';
import { Route } from 'react-router';

import { CAMPAIGN_PRODUCTS, MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';

import { CampaignProductsPage } from './CampaignProductsPage';
import { PageNotFound } from '../PageNotFound';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';
import { useAgeCategorySearchParam } from '../../shared/utils/useAgeCategorySearchParam';
import { Navigate, Routes } from 'react-router-dom';
import useShopLanguages from '../../shared/hooks/useShopLanguages';
import { useAuthentication } from '../../app-store/authentication/useAuthentication';

const CampaignProductsRouteSwitch: FC<{ shopLanguage?: string }> = ({ shopLanguage }) => {
    const campaignsEnabled = useFeature(CAMPAIGN_PRODUCTS);
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});
    const { shopLanguages } = useShopLanguages();
    const isMainShopLanguage = !!shopLanguages.find(sl => sl.shopLanguageId === shopLanguage);
    const {
        spoc: { distributionTerritory: currentTerritory }
    } = useAuthentication();

    const isDETerritory = currentTerritory.startsWith('DE_');

    if (!campaignsEnabled || (shopLanguage && (!isMainShopLanguage || isDETerritory))) {
        return <Navigate to={isMultiLanguageShopEnabled ? '/shop' : '/catalogue'} replace />;
    }

    return (
        <Routes>
            <Route index element={<Navigate to={{ pathname: 'all', search: searchParams.toString() }} replace />} />
            <Route
                path=":loanFormat"
                element={
                    <CheckLoanFormat>
                        <CampaignProductsPage />
                    </CheckLoanFormat>
                }
            />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default CampaignProductsRouteSwitch;
